let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dFR0m")).then(() => parcelRequire('dY9zr'));